var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time_wrapper"},[_c('div',[_vm._v(_vm._s(_vm.d ? _vm.d : 0))]),_vm._v("天 "),_c('div',[_vm._v(_vm._s(_vm.h ? _vm.h : 0))]),_vm._v("时 "),_c('div',[_vm._v(_vm._s(_vm.m ? _vm.m : 0))]),_vm._v("分 "),_c('div',[_vm._v(_vm._s(_vm.s ? _vm.s : 0))]),_vm._v("秒 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }